import Section from 'components/base/Section';
import EComCustomerOrdersTable from 'components/tables/EComCustomerOrdersTable';

const MyOrders = () => {
  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        <h2 className="mb-5">My Orders</h2>
        <EComCustomerOrdersTable />
      </Section>
    </div>
  );
};

export default MyOrders;
